import React, { useState } from 'react';
import { Button, Modal, Form, Input } from 'antd';

const EmployeeAddForm = ({ visible, onCreate, onCancel }) => {

  const [form] = Form.useForm();
  
  return (
    <Modal
      visible={visible}
      title="Create a new collection"
      okText="Create"
      cancelText="Cancel"
      onCancel={onCancel}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            form.resetFields();
            onCreate(values);
          })
          .catch((info) => {
            console.log('Validate Failed:', info);
          });
      }}

    >
      <Form
        form={form}
        layout="vertical"
        name="EmployeeForm"
        initialValues={{
          EmployeeName:'',
          EmployeePhoto:'https://joeschmoe.io/api/v1/random',
          EmployeePhone:'',
          EmployeeEmail:'',
          EmployeePassword:'',
      }}
      >
        <Form.Item
          name="EmployeeName"
          label="Employee Name"
          rules={[{ required: true, message: 'Please input your Name!' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item 
          name="EmployeePhoto" 
          label="Employee Photo"
        >
          <Input />
        </Form.Item>
        
        <Form.Item 
          name="EmployeePhone" 
          label="Employee Phone"
          validateTrigger='onBlur'
          rules={[
            // {required:true,
            //   message:'Please enter the Phone number'
            // },
            {
              required:false,
              pattern: new RegExp(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/, "g"),
              message:'Please enter the correct format'
            }
          ]}
        >
          <Input addonBefore={'+1'}/>
        </Form.Item>

        <Form.Item 
          name="EmployeeEmail" 
          label="Employee Email"
          rules={[
            {type: 'email',message: 'The input is not valid E-mail!',},
            { required: true, message: 'Please input your Email!' }
          ]}
          >
          <Input />
        </Form.Item>
        <Form.Item 
          name="EmployeePassword" 
          label="Employee Password"
          rules={[{ required: true, message: 'Please input your password!' }]}
        >
          <Input.Password />
        </Form.Item>
        
      </Form>
    </Modal>
  );
};

const EmployeeAdd = ( props ) => {
  const [visible, setVisible] = useState(false);

  const onCreate = (values) => {
    props.addEmployee(values)
    setVisible(false);
  };

  return (
    <div>
      <Button
        type="primary"
        onClick={() => {
          setVisible(true);
        }}
      >
        Add New Employee
      </Button>
      <EmployeeAddForm
        visible={visible}
        onCreate={onCreate}
        onCancel={() => {
          setVisible(false);
        }}
      />
    </div>
  );
};

export default EmployeeAdd